import React from 'react';
import { Box, Container, Typography, useTheme } from '@mui/material';

const Footer: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: theme.palette.mode === 'light'
          ? theme.palette.grey[200]
          : theme.palette.grey[800],
        position: {
          xs: 'relative',
          sm: 'relative'
        },
        width: '100%',
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="body1" align="center">
          Sistema de Gestión de Vehículos GNV {new Date().getFullYear()}
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          Desarrollado por el equipo desarrollo de CCC DE COLOMBIA
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
